export default "__VITE_ASSET__d1f0d0f9__"